export default __webpack_public_path__ + "static/media/mail.a38484af.svg";